export const preventDefaultHandler = (callback) => (event) => {
    callback();
    event.preventDefault();
    event.stopPropagation();
};
